// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__MvWM9","header":"ReportDetails_header__3n2ID","title":"ReportDetails_title__2PQpD","left":"ReportDetails_left__3SML5"};